import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import LandingMediaKitProposal from '../TNOMediaKitProposal';
import { isStaticFullLandingSlug } from '../../../data/staticLandingSlugs';

/**
 * Vista que carga y renderiza propuestas desde el API (dinámicas).
 * Ruta: /show/:slug — landings dedicadas redirigen a /:slug sin /show.
 */
const LandingMediaKitDynamic = (props) => {
  const { slug } = useParams();
  if (slug && isStaticFullLandingSlug(slug)) {
    return <Redirect to={`/${slug}`} />;
  }
  return <LandingMediaKitProposal {...props} staticOnly={false} />;
};

export default LandingMediaKitDynamic;
